<template>
  <v-container fluid v-if="tiene_empresa">
    <v-data-table
      v-if="flag == 'dataTable'"
      v-model="ingreso_seleccionado"
      :headers="headers_ingresos"
      :items="items_ingresos"
      :loading="loading"
      dense
      :search="search"
      item-key="id_cabecera_ingreso"
      show-select
      single-select
    >
      <template v-slot:top>
        <v-toolbar elevation="0" dense>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="listarIngresosDiarios()" v-bind="attrs" v-on="on">
                fa-solid fa-rotate-right
              </v-icon>
            </template>
            <span>Refrescar tabla</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            label="Buscar"
            outlined
            dense
            hide-details
          ></v-text-field>
          <v-btn class="mx-3" color="primary" @click="listarContratos()" :disabled="ingreso_seleccionado.length == 0"
            >Estado de cuenta</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="nuevoIngresoDiario()">Nuevo</v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.fecha`]="{ item }">
        <span>{{ formatoFecha(item.fecha) }}</span>
      </template>
      <template v-slot:[`item.total_abono`]="{ item }">
        <span>
          $
          {{
            (
              Number(item.efectivo) +
              Number(item.cheque) +
              Number(item.remesa) +
              Number(item.transferencia) +
              Number(item.otros_monto)
            ).toFixed(2)
          }}</span
        >
      </template>

      <template v-slot:[`item.edit`]="{ item }">
        <v-icon @click="editarIngresoDiario(item)"
          >fa-solid fa-pen-to-square</v-icon
        >
      </template>
    </v-data-table>
    <!-- CABECERA -->
    <v-row no-gutters v-if="flag == 'nuevo' || flag == 'editar'">
      <v-col cols="5" class="pa-1">
        <v-text-field
          v-model="tipo_ingreso[0].nom_tipo_ingreso"
          label="Tipo de ingreso"
          outlined
          dense
          hide-details
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="3" class="pa-1">
        <v-text-field
          v-model="codigo_ingreso_diario"
          label="Código"
          outlined
          dense
          hide-details
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="4"></v-col>
      <v-col cols="2" class="pa-1">
        <v-text-field
          v-model="fecha"
          label="Fecha"
          type="date"
          outlined
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="3" class="pa-1">
        <v-text-field
          v-model="referencia"
          label="Referencia"
          outlined
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="7"></v-col>
      <v-col cols="2" class="pa-1">
        <v-text-field
          v-model="cliente"
          label="Cliente"
          outlined
          dense
          hide-details
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="auto" class="pa-1" align-self="center">
        <v-btn
          color="primary"
          @click="listarClientes()"
          :loading="loading_clientes"
          :disabled="flag == 'editar'"
        >
          <v-icon>fa-solid fa-magnifying-glass</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="pa-1">
        <v-text-field
          v-model="nombre_cliente"
          label="Nombre"
          outlined
          dense
          hide-details
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="pa-1">
        <v-textarea
          v-model="comentario"
          label="Comentario"
          outlined
          dense
          hide-details
          auto-grow
          row-height="12"
        ></v-textarea>
      </v-col>
    </v-row>
    <!-- MONTOS -->
    <v-row no-gutters v-if="flag == 'nuevo' || flag == 'editar'">
      <v-col cols="2" class="pa-1">
        <v-text-field
          v-model="monto_efectivo"
          label="Monto efectivo"
          outlined
          dense
          hide-details
          type="number"
          min="0"
          @keydown="blockNegative"
          @paste="sanitizePaste"
          prefix="$"
          :readonly="flag == 'editar'"
        ></v-text-field>
      </v-col>
      <v-col cols="2" class="pa-1">
        <v-text-field
          v-model="monto_cheque"
          label="Monto cheque"
          outlined
          dense
          hide-details
          type="number"
          min="0"
          @keydown="blockNegative"
          @paste="sanitizePaste"
          prefix="$"
          :readonly="flag == 'editar'"
        ></v-text-field>
      </v-col>
      <v-col cols="2" class="pa-1">
        <v-text-field
          v-model="monto_remesa"
          label="Monto remesa"
          outlined
          dense
          hide-details
          type="number"
          min="0"
          @keydown="blockNegative"
          @paste="sanitizePaste"
          prefix="$"
          :readonly="flag == 'editar'"
        ></v-text-field>
      </v-col>
      <v-col cols="2" class="pa-1">
        <v-text-field
          v-model="monto_transferencia"
          label="Monto transferencia"
          outlined
          dense
          hide-details
          type="number"
          min="0"
          @keydown="blockNegative"
          @paste="sanitizePaste"
          prefix="$"
          :readonly="flag == 'editar'"
        ></v-text-field>
      </v-col>
      <v-col cols="2" class="pa-1">
        <v-text-field
          v-model="monto_otros"
          label="Otros monto"
          outlined
          dense
          hide-details
          type="number"
          min="0"
          @keydown="blockNegative"
          @paste="sanitizePaste"
          prefix="$"
          :readonly="flag == 'editar'"
        ></v-text-field>
      </v-col>
      <v-col cols="2" class="pa-1">
        <v-text-field
          v-model="calculoMontoTotal"
          label="Monto total"
          outlined
          dense
          hide-details
          readonly
          prefix="$"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- DETALLES -->
    <v-row no-gutters v-if="flag == 'nuevo' || flag == 'editar'">
      <v-col cols="12" class="pa-1">
        <v-data-table
          v-model="detalles_seleccionados"
          :headers="headers_detalles"
          :items="items_detalles"
          dense
          class="elevation-1"
          item-key="id_factura"
          :show-select="flag == 'nuevo'"
          @item-selected="facturaSeleccionado"
        >
          <template v-slot:[`item.fecha`]="{ item }">
            <span> {{ formatoFecha(item.fecha) }} </span>
          </template>
          <template v-slot:[`item.saldo`]="{ item }">
            <span> $ {{ item.saldo.toFixed(2) }} </span>
          </template>
          <template v-slot:[`item.abono`]="{ item }">
            <span> $ {{ Number(item.abono).toFixed(2) }} </span>
          </template>
          <template v-slot:[`item.nuevo_saldo`]="{ item }">
            <span> $ {{ Number(item.nuevo_saldo).toFixed(2) }} </span>
          </template>
          <template v-slot:[`footer.prepend`]>
            <v-row>
              <v-col cols="auto" align-self="center">
                <div class="title">Totales</div>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="calculoTotalFacturas"
                  outlined
                  dense
                  hide-details
                  readonly
                  prefix="$"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="total_abonos"
                  outlined
                  dense
                  hide-details
                  readonly
                  prefix="$"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- BOTONES ACCIONES -->
    <v-row no-gutters v-if="flag == 'nuevo' || flag == 'editar'">
      <v-col cols="auto" class="pa-1" v-if="flag == 'nuevo'">
        <v-btn color="primary" @click="crearIngresoDiario()">Guardar</v-btn>
      </v-col>
      <v-col cols="auto" class="pa-1" v-if="flag == 'editar'">
        <v-btn color="primary" @click="actualizarIngresoDiario()"
          >Actualizar</v-btn
        >
      </v-col>
      <v-col cols="auto" class="pa-1" v-if="flag == 'editar'">
        <v-btn color="red" dark @click="dialog_confirmar_eliminar = true"
          >Eliminar</v-btn
        >
      </v-col>
      <v-col cols="auto" class="pa-1">
        <v-btn color="grey" dark @click="cancelarIngresoDiario()"
          >Cancelar</v-btn
        >
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_clientes" width="1000" persistent>
      <v-card>
        <v-card-text>
          <v-data-table
            :headers="headers_clientes"
            :items="items_clientes"
            :search="search_cliente"
            dense
          >
            <template v-slot:top>
              <v-toolbar elevation="0">
                <v-toolbar-title class="font-weight-medium headline"
                  >Clientes</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search_cliente"
                  label="Buscar"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-icon @click="dialog_clientes = false" large
                  >fa-solid fa-xmark</v-icon
                >
              </v-toolbar>
            </template>
            <template v-slot:[`item.accion_selec`]="{ item }">
              <v-btn @click="clienteSeleccionado(item)" text block>
                <v-icon>fa-solid fa-hand-point-up</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_confirmar_eliminar" width="500">
      <v-card>
        <v-card-title>¿Esta seguro de eliminar este registro?</v-card-title>
        <v-card-text class="title font-weight-black">
          {{ codigo_ingreso_diario }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" dark @click="eliminarIngresoDiario()"
            >Eliminar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="grey" dark @click="dialog_confirmar_eliminar = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_preview_report" fullscreen persistent>
      <v-toolbar flat dense>
        <v-toolbar-title> DOCUMENTO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="dialog_preview_report = !dialog_preview_report"
          >far fa-times-circle</v-icon
        >
      </v-toolbar>
      <iframe :src="base64_doc" id="myPDF" frameborder="0" />
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      timeout="-1"
      color="blue"
      multi-line
      elevation="24"
      outlined
    >
      {{ snackbar_text }}

      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar = false">
          <v-icon>fa-regular fa-circle-xmark</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data: () => ({
    search: "",
    search_cliente: "",
    flag: "dataTable",
    headers_ingresos: [
      { text: "Fecha", value: "fecha" },
      { text: "Código", value: "cod_ingreso" },
      { text: "Referencia", value: "referencia" },
      { text: "Comentario", value: "comentario" },
      { text: "Cliente", value: "codigo_cliente", align: "center" },
      { text: "Nombre", value: "nombre_cliente" },
      { text: "Total abono", value: "total_abono", align: "center" },
      { text: "Editar", value: "edit", align: "center" },
    ],
    items_ingresos: [],
    snackbar: false,
    snackbar_text: "",
    tipo_ingreso: [
      {
        cod_tipo_ingreso: "RC",
        nom_tipo_ingreso: "RC - RECUPERACION DE CREDITO",
      },
    ],
    codigo_ingreso_diario: "CXC00000000000000001",
    fecha: "",
    referencia: "",
    id_cabecera_ingreso: null,
    id_cliente: null,
    id_empresa: null,
    cliente: "",
    nombre_cliente: "",
    comentario: "",
    monto_efectivo: null,
    monto_cheque: null,
    monto_remesa: null,
    monto_transferencia: null,
    monto_otros: null,
    monto_total: null,
    headers_detalles: [
      { text: "Fecha", value: "fecha" },
      { text: "Tipo", value: "cod_doc_fiscal" },
      { text: "Documento", value: "numero_control" },
      { text: "Saldo", value: "saldo", align: "center" },
      { text: "Abono", value: "abono", align: "center" },
      { text: "Nuevo Saldo", value: "nuevo_saldo", align: "center" },
    ],
    items_detalles: [],
    detalles_seleccionados: [],
    dialog_clientes: false,
    headers_clientes: [
      { text: "Código", value: "codigo" },
      { text: "Nombre", value: "nombre" },
      { text: "Dirección", value: "direccion" },
      { text: "Telefono", value: "telefono" },
      { text: "Registro", value: "registro" },
      { text: "Seleccionar", value: "accion_selec" },
    ],
    items_clientes: [],
    loading_clientes: false,
    total_facturas: null,
    total_abonos: null,
    dialog_confirmar_eliminar: false,
    loading: false,
    base64_doc: "",
    dialog_preview_report: false,
    dialog_estado_cuenta: false,
    ingreso_seleccionado: [],
  }),
  computed: {
    tiene_empresa() {
      if (this.$store.state.emp.id_empresa) {
        this.listarIngresosDiarios();
        return true;
      } else {
        return false;
      }
    },
    calculoMontoTotal() {
      this.monto_total = Number(
        Number(this.monto_efectivo) +
          Number(this.monto_cheque) +
          Number(this.monto_remesa) +
          Number(this.monto_transferencia) +
          Number(this.monto_otros)
      ).toFixed(2);

      return this.monto_total;
    },
    calculoTotalFacturas() {
      if (this.items_detalles.length > 0) {
        for (var i = 0; i < this.items_detalles.length; i++) {
          this.total_facturas =
            Number(this.total_facturas) + Number(this.items_detalles[i].saldo);
        }
        return Number(this.total_facturas).toFixed(2);
      } else {
        return Number(0.0).toFixed(2);
      }
    },
  },
  created() {
    this.fecha = this.formatoFecha(new Date());
  },
  methods: {
    listarContratos() {
      axios
        .get(
          "api/ContratoCliente/Listar/" +
            this.ingreso_seleccionado[0].id_cliente
        )
        .then((response) => {
          if (response.data.length == 0) {
            this.snackbar_text =
              "El cliente no posee registro de contrato, favor de crear uno";
            this.snackbar = true;
            return;
          }
          this.generarEstadoCuenta();
        });
    },
    generarEstadoCuenta() {
      axios
        .post("api/facturas/ReporteEstadoCuenta", {
          id_cabecera_ingreso: this.ingreso_seleccionado[0].id_cabecera_ingreso,
          id_cliente: this.ingreso_seleccionado[0].id_cliente,
          tipo_doc: "pdf",
          server: process.env.VUE_APP_CRYSTAL_SERVER,
        })
        .then((response) => {
          this.base64_doc = "data:application/pdf;base64," + response.data;
          this.dialog_preview_report = true;
        });
    },
    nuevoIngresoDiario() {
      this.flag = "nuevo";

      this.listarCodigoIngreso();
    },
    cancelarIngresoDiario() {
      this.flag = "dataTable";

      this.codigo_ingreso_diario = "CXC00000000000000001";
      this.referencia = "";
      this.id_cliente = "";
      this.cliente = null;
      this.nombre_cliente = "";
      this.fecha = this.formatoFecha(new Date());
      this.comentario = "";
      this.monto_efectivo = null;
      this.monto_cheque = null;
      this.monto_remesa = null;
      this.monto_transferencia = null;
      this.monto_otros = null;
      this.monto_total = null;
      this.items_clientes = [];
      this.items_detalles = [];
      this.detalles_seleccionados = [];
      this.total_facturas = null;
      this.total_abonos = null;
    },
    listarIngresosDiarios() {
      this.loading = true;
      axios
        .get("api/IngresosDiarios/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          //console.log(response.data);
          this.items_ingresos = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    listarDetallesIngresosDiarios(item) {
      axios
        .get("api/IngresosDiarios/ListarDetalles/" + item.id_cabecera_ingreso)
        .then((response) => {
          //console.log(response.data);
          this.items_detalles = response.data;
        });
    },
    listarClientes() {
      this.loading_clientes = true;
      axios
        .get("api/Clientes/ListarTodos/" + this.$store.state.emp.id_empresa)
        .then((respone) => {
          //console.log(respone.data);
          this.loading_clientes = false;
          this.items_clientes = respone.data;
          this.dialog_clientes = true;
        })
        .catch(() => {
          this.loading_clientes = false;
        });
    },
    clienteSeleccionado(item) {
      //console.log(item);
      this.id_cliente = item.id_cliente;
      this.cliente = item.codigo;
      this.nombre_cliente = item.nombre;
      this.dialog_clientes = false;

      this.listarFacturas(item.id_cliente);
    },
    facturaSeleccionado(data) {
      //console.log(data);
      var index = null;

      if (data.value) {
        index = this.items_detalles.findIndex((obj) => obj.id_factura == data.item.id_factura);

        if (Number(this.monto_total) == Number(this.total_abonos)) { return; }

        if ((Number(this.monto_total) - Number(this.total_abonos)) > Number(this.items_detalles[index].saldo)) {
          if (Number(this.monto_total) > Number(this.total_abonos) && this.total_abonos > 0) {
            this.items_detalles[index].nuevo_saldo = Number(this.items_detalles[index].nuevo_saldo) - Number(this.total_abonos);
            this.items_detalles[index].abono = Number(this.monto_total) - Number(this.total_abonos);
            this.total_abonos = (Number(this.total_abonos) + Number(this.items_detalles[index].abono)).toFixed(2);
          } else {
            this.items_detalles[index].nuevo_saldo = Number(0.0);
            this.items_detalles[index].abono = Number(this.items_detalles[index].saldo);
            this.total_abonos = (Number(this.total_abonos) + Number(this.items_detalles[index].saldo)).toFixed(2);
          }
        } else {
          this.items_detalles[index].abono = Number(this.monto_total) - Number(this.total_abonos);
          this.items_detalles[index].nuevo_saldo = (Number(this.items_detalles[index].saldo) - Number(this.items_detalles[index].abono)).toFixed(2);
          this.total_abonos = (Number(this.total_abonos) + Number(this.items_detalles[index].abono)).toFixed(2);
        }
      } else {
        index = this.items_detalles.findIndex((obj) => obj.id_factura == data.item.id_factura);

        if (this.items_detalles[index].abono == 0) {
          return;
        }

        if (Number(this.monto_total) > Number(this.items_detalles[index].saldo)) {
          this.items_detalles[index].nuevo_saldo = Number(this.items_detalles[index].saldo);
          this.total_abonos = (Number(this.total_abonos) - Number(this.items_detalles[index].abono)).toFixed(2);
        } else {
          this.items_detalles[index].nuevo_saldo = (Number(this.items_detalles[index].nuevo_saldo) + Number(this.monto_total)).toFixed(2);
          this.total_abonos = (Number(this.total_abonos) - Number(this.items_detalles[index].abono)).toFixed(2);
        }

        this.items_detalles[index].abono = Number(0.0).toFixed(2);
      }
    },
    listarFacturas(id_cliente) {
      axios
        .get(
          "api/Facturas/ListarPorClienteID/" +
            this.$store.state.emp.id_empresa +
            "/" +
            id_cliente
        )
        .then((respone) => {
          this.total_abonos = Number(0.0).toFixed(2);
          this.items_detalles = respone.data;
          this.items_detalles = this.items_detalles.map((v) => ({
            ...v,
            abono: 0.0,
          }));
          this.items_detalles = this.items_detalles.map((v) => ({
            ...v,
            nuevo_saldo: v.saldo,
          }));
        });
    },
    crearIngresoDiario() {
      if (!this.cliente) {
        this.snackbar_text = "Debe de seleccionar un cliente.";
        this.snackbar = true;
        return;
      }
      if (this.monto_total > this.total_abonos) {
        this.snackbar_text =
          "El monto total no puede ser mayor al total abonado.";
        this.snackbar = true;
        return;
      }
      if (this.monto_total != this.total_abonos) {
        this.snackbar_text = "El monto total y el total abonado no coinciden.";
        this.snackbar = true;
        return;
      }
      if (this.monto_total == 0) {
        this.snackbar_text = "El total no puede ir a cero.";
        this.snackbar = true;
        return;
      }

      var detalles_ingresos = [];
      for (var i = 0; i < this.detalles_seleccionados.length; i++) {
        if (Number(this.detalles_seleccionados[i].abono) > 0) {
          detalles_ingresos.push({
            id_factura: this.detalles_seleccionados[i].id_factura,
            cod_doc_fiscal: this.detalles_seleccionados[i].cod_doc_fiscal,
            numero_control: this.detalles_seleccionados[i].numero_control,
            fecha: this.detalles_seleccionados[i].fecha,
            saldo: Number(this.detalles_seleccionados[i].saldo),
            abono: Number(this.detalles_seleccionados[i].abono),
            nuevo_saldo: Number(this.detalles_seleccionados[i].nuevo_saldo),
          });
        }
      }

      axios
        .post("api/IngresosDiarios/Crear", {
          id_cliente: this.id_cliente,
          id_empresa: this.$store.state.emp.id_empresa,
          cod_tipo_ingreso: this.tipo_ingreso[0].cod_tipo_ingreso,
          cod_ingreso: this.codigo_ingreso_diario,
          fecha: this.fecha,
          referencia: this.referencia,
          comentario: this.comentario,
          efectivo: this.monto_efectivo,
          cheque: this.monto_cheque,
          remesa: this.monto_remesa,
          transferencia: this.monto_transferencia,
          otros_monto: this.monto_otros,
          detalleIngreso: detalles_ingresos,
        })
        .then((respone) => {
          if (respone.data == "409") {
            this.snackbar_text =
              "El registro con el código " +
              this.codigo_ingreso_diario +
              " ya existe, cancelar y recargar para volver a crear uno nuevo.";
            this.snackbar = true;
            return;
          }

          this.snackbar_text = "Registro creado con exito.";
          this.snackbar = true;

          this.flag = "dataTable";
          this.cancelarIngresoDiario();
          this.listarIngresosDiarios();
        })
        .catch(() => {
          this.snackbar_text = "No se pudo guardar el registro.";
          this.snackbar = true;
        });
    },
    actualizarIngresoDiario() {
      if (this.monto_total > this.total_abonos) {
        this.snackbar_text =
          "El monto total no puede ser mayor al total abonado.";
        this.snackbar = true;
        return;
      }
      if (this.monto_total != this.total_abonos) {
        this.snackbar_text = "El monto total y el total abonado no coinciden.";
        this.snackbar = true;
        return;
      }
      if (this.monto_total == 0) {
        this.snackbar_text = "El total no puede ir a cero.";
        this.snackbar = true;
        return;
      }

      var detalles_ingresos = [];
      for (var i = 0; i < this.detalles_seleccionados.length; i++) {
        if (Number(this.detalles_seleccionados[i].abono) > 0) {
          detalles_ingresos.push({
            id_detalle_ingreso:
              this.detalles_seleccionados[i].id_detalle_ingreso,
            id_cabecera_ingreso:
              this.detalles_seleccionados[i].id_cabecera_ingreso,
            id_empresa: this.detalles_seleccionados[i].id_empresa,
            cod_doc_fiscal: this.detalles_seleccionados[i].cod_doc_fiscal,
            numero_control: this.detalles_seleccionados[i].numero_control,
            fecha: this.detalles_seleccionados[i].fecha,
            saldo: Number(this.detalles_seleccionados[i].saldo),
            abono: Number(this.detalles_seleccionados[i].abono),
            nuevo_saldo: Number(this.detalles_seleccionados[i].nuevo_saldo),
          });
        }
      }

      axios
        .post("api/IngresosDiarios/Actualizar", {
          id_cabecera_ingreso: this.id_cabecera_ingreso,
          id_cliente: this.id_cliente,
          id_empresa: this.$store.state.emp.id_empresa,
          cod_tipo_ingreso: this.tipo_ingreso[0].cod_tipo_ingreso,
          cod_ingreso: this.codigo_ingreso_diario,
          fecha: this.fecha,
          referencia: this.referencia,
          comentario: this.comentario,
          efectivo: this.monto_efectivo,
          cheque: this.monto_cheque,
          remesa: this.monto_remesa,
          transferencia: this.monto_transferencia,
          otros_monto: this.monto_otros,
          detalleIngreso: detalles_ingresos,
        })
        .then(() => {
          this.snackbar_text = "Registro actualizado con exito.";
          this.snackbar = true;

          this.flag = "dataTable";
          this.cancelarIngresoDiario();
          this.listarIngresosDiarios();
        })
        .catch(() => {
          this.snackbar_text = "No se pudo actualizar el registro.";
          this.snackbar = true;
        });
    },
    editarIngresoDiario(item) {
      //console.log(item);
      this.id_cabecera_ingreso = item.id_cabecera_ingreso;
      this.id_cliente = item.id_cliente;
      this.id_empresa = item.id_empresa;
      this.codigo_ingreso_diario = item.cod_ingreso;
      this.fecha = this.formatoFecha(item.fecha);
      this.referencia = item.referencia;
      this.cliente = item.codigo_cliente;
      this.nombre_cliente = item.nombre_cliente;
      this.comentario = item.comentario;
      this.monto_efectivo =
        item.efectivo == null ? Number(0.0) : Number(item.efectivo);
      this.monto_cheque =
        item.cheque == null ? Number(0.0) : Number(item.cheque);
      this.monto_remesa =
        item.remesa == null ? Number(0.0) : Number(item.remesa);
      this.monto_transferencia =
        item.transferencia == null ? Number(0.0) : Number(item.transferencia);
      this.monto_otros =
        item.otros_monto == null ? Number(0.0) : Number(item.otros_monto);
      this.total_abonos = this.calculoMontoTotal;
      this.monto_total = this.calculoMontoTotal;

      this.listarDetallesIngresosDiarios(item);

      this.flag = "editar";
    },
    listarCodigoIngreso() {
      axios
        .get(
          "api/IngresosDiarios/ListarCodigoIngreso/" +
            this.$store.state.emp.id_empresa
        )
        .then((response) => {
          //console.log(response.data);
          var corr_cod_ingreso = response.data
            .split("CXC")[1]
            .replace(/^0+/, "");

          corr_cod_ingreso =
            corr_cod_ingreso.length == 0 ? "0" : corr_cod_ingreso;

          var zeros_cod_ingreso = response.data.substring(
            0,
            20 - corr_cod_ingreso.length
          );

          this.codigo_ingreso_diario =
            zeros_cod_ingreso + (Number(corr_cod_ingreso) + 1);
        });
    },
    eliminarIngresoDiario() {
      axios
        .delete("api/IngresosDiarios/Eliminar/" + this.id_cabecera_ingreso)
        .then(() => {
          this.snackbar_text = "Registro eliminado.";
          this.snackbar = true;

          this.flag = "dataTable";
          this.dialog_confirmar_eliminar = false;
          this.cancelarIngresoDiario();
          this.listarIngresosDiarios();
        })
        .catch(() => {
          this.snackbar_text = "No se puedo eliminar el registro.";
          this.snackbar = true;
        });
    },
    blockNegative(e) {
      if (
        e.key === "-" ||
        e.key === "Minus" ||
        e.key === "+" ||
        e.key === "Plus" ||
        e.key === "e" ||
        e.key === "E"
      ) {
        e.preventDefault();
      }
    },
    sanitizePaste(e) {
      const pasted = (e.clipboardData || window.clipboardData).getData("text");
      if (pasted.includes("-")) {
        e.preventDefault();
        const sanitized = pasted.replace(/-/g, "");
        this.amount = parseFloat(sanitized) || 0;
      }
    },
    formatoFecha(data) {
      if (data) {
        return moment(data).format("YYYY-MM-DD");
      }
    },
  },
};
</script>